import { Component, AfterViewInit, ViewEncapsulation, ViewChild, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DatatableService } from 'src/app/services/datatable.service';
import { RoleService } from 'src/app/services/role/role.service';
import { RoleModalService } from 'src/app/services/role-modal.service';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';

declare const $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-cm-edit-role',
  templateUrl: './cm-edit-role.component.html',
  styleUrls: ['./cm-edit-role.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CmEditRoleComponent extends DestructorComponent implements OnInit, AfterViewInit {

  roleData: any = null;
  roleId: string = '';

  constructor(
    private datatableService: DatatableService,
    private route: ActivatedRoute,
    private roleService: RoleService,
    private roleModalService: RoleModalService
  ) {
    super();
  }

  @ViewChild('jstreeContainer', { static: false }) jstreeContainer!: ElementRef;

  ngOnInit(): void {
    // Get role ID from route parameters
    this.roleId = this.route.snapshot.params['id'];
    if (this.roleId) {
      this.getRoleData();
    }
  }

  ngAfterViewInit(): void {
    this.datatableService.init('kt_table_role_view');

    $(this.jstreeContainer.nativeElement).jstree({
      plugins: ['wholerow', 'checkbox', 'types'],
      core: {
        themes: {
          responsive: false,
        },
        data: [
          {
            text: 'Same but with checkboxes',
            children: [
              {
                text: 'initially selected',
                state: { selected: true },
              },
              {
                text: 'custom icon',
                icon: '',
              },
              {
                text: 'initially open',
                icon: 'ki-solid ki-folder text-default',
                state: { opened: true },
                children: ['Another node'],
              },
              {
                text: 'custom icon',
                icon: '',
              },
              {
                text: 'disabled node',
                icon: '',
                state: { disabled: true },
              },
            ],
          },
          'And wholerow selection',
        ],
      },
      types: {
        default: {
          icon: 'ki-solid ki-folder text-warning',
        },
        file: {
          icon: 'ki-solid ki-file text-warning',
        },
      },
    });
  }

  // Get role data from API
  getRoleData(): void {
    this.subscriptions.push(
      this.roleService.GetDataById(this.roleId).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.roleData = response.data;
            console.log('Role data loaded:', this.roleData);
          }
        },
        error: (error) => {
          console.error('Error fetching role data:', error);
        }
      })
    );
  }

  // Get permission description for display
  getPermissionDescription(permissions: any): string[] {
    if (!permissions) return [];

    const descriptions: string[] = [];
    Object.keys(permissions).forEach(slug => {
      const permission = permissions[slug];
      if (permission && (permission.add || permission.edit || permission.view)) {
        const capabilities: string[] = [];
        if (permission.view) capabilities.push('Can View');
        if (permission.add) capabilities.push('Can Add');
        if (permission.edit) capabilities.push('Can Edit');

        descriptions.push(`${permission.name}: ${capabilities.join(', ')}`);
      }
    });

    return descriptions;
  }

  // Method to handle edit role button click
  editRole(): void {
    if (this.roleData) {
      // Set the selected role in the service
      this.roleModalService.setSelectedRole(this.roleData);

      // Open the modal
      const modalElement = document.getElementById('kt_modal_update_role');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  // Method to handle role updated event
  onRoleUpdated(): void {
    console.log('Role updated, refreshing role data...');
    this.getRoleData(); // Refresh the role data
  }

  // Handle role added event from modal
  onRoleAdded(): void {
    console.log('Role added successfully! Refreshing roles list...');
    // Add specific refresh logic here if needed
  }
}